var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer_tab"},[_c('div',{staticClass:"tab_list"},_vm._l((_vm.tabList),function(item){return _c('div',{key:item.id,staticClass:"tab_item",class:_vm.activeId == item.id ? 'tab_active' : '',on:{"click":function($event){return _vm.changeTab(item)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b44efeac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 